import React from 'react';
import { Box, Card } from '@mui/material';
import { useMessengerContext } from '@juno/utils';
import { Conversation } from './Conversation/Conversation';
import { Conversations } from './Conversations/Conversations';
import './styles.css';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`messenger-tabpanel-${index}`}
      aria-labelledby={`messenger-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export const messengerTabMap = {
  Messenger: 0,
  People: 1,
};

export const Messenger = () => {
  const { messengerTab, isConversation } = useMessengerContext();

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', position: 'relative' }}>
      <Card
        sx={{
          flexGrow: 1,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: 0, // Adjust this value to control the overlap from the left
        }}
      >
        <CustomTabPanel value={messengerTab} index={0}>
          {isConversation ? <Conversation /> : <Conversations />}
        </CustomTabPanel>
      </Card>
    </Box>
  );
};

export default Messenger;
